var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLapizEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.25 9.25H8C7.33696 9.25 6.70107 9.51339 6.23223 9.98223C5.76339 10.4511 5.5 11.087 5.5 11.75V23C5.5 23.663 5.76339 24.2989 6.23223 24.7678C6.70107 25.2366 7.33696 25.5 8 25.5H19.25C19.913 25.5 20.5489 25.2366 21.0178 24.7678C21.4866 24.2989 21.75 23.663 21.75 23V21.75",
    stroke: "#00C46B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5 6.75013L24.25 10.5001M25.9813 8.73138C26.4736 8.23908 26.7501 7.57136 26.7501 6.87513C26.7501 6.1789 26.4736 5.51119 25.9813 5.01888C25.4889 4.52658 24.8212 4.25 24.125 4.25C23.4288 4.25 22.7611 4.52658 22.2688 5.01888L11.75 15.5001V19.2501H15.5L25.9813 8.73138Z",
    stroke: "#00C46B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapizEdit);
export default __webpack_public_path__ + "static/media/lapiz-edit.b1e5691bb610de0c5e875ab2050e41cb.svg";
export { ForwardRef as ReactComponent };